module.exports = __webpack_public_path__ + "static/media/nebulafix-1.0beacfc7.jpg";